(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-cta"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    class StickyProductController {
      constructor() {
        this.elements = this.getElements();
        this.state = {
          isTriggerVisible: true,
          isFooterIntersecting: false,
        };

        this.init();
      }

      getElements() {
        const stickyProduct = document.querySelector('#stickyProduct');
        if (!stickyProduct) {
          return;
        }

        const stickyButton = stickyProduct.querySelector('#stickyCTAButton');
        if (!stickyButton) {
          return;
        }

        return {
          stickyProduct: stickyProduct,
          stickyButton: stickyButton,
          triggerElement: document.querySelector('[data-sticky-trigger]'),
          scrollTarget: document.querySelector('[data-sticky-scroll-target]'),
          footerElement: document.querySelector('footer'),
          isSingleProduct: stickyButton.dataset.singleProduct === 'true',
          position: stickyProduct.dataset.stickyPosition || 'top',
        };
      }

      init() {
        if (!this.elements) {
          return;
        }

        this.setupObservers();
        this.setupEventListeners();
        this.setupResizeHandling();
        this.updateVisibility();
      }

      setupObservers() {
        if (this.elements.triggerElement) {
          const triggerObserver = new IntersectionObserver(this.handleTriggerIntersection.bind(this), {
            threshold: 0,
            rootMargin: '0px',
          });

          triggerObserver.observe(this.elements.triggerElement);
        }

        // Observer for footer visibility
        if (this.elements.footerElement) {
          const footerObserver = new IntersectionObserver(this.handleFooterIntersection.bind(this), {
            threshold: 0,
            rootMargin: '0px 0px -100px 0px',
          });

          footerObserver.observe(this.elements.footerElement);
        }
      }

      handleTriggerIntersection(entries) {
        const entry = entries[0];
        // Trigger has been scrolled past only when it's above the viewport.
        // Using boundingClientRect avoids relying on offsetTop, which is
        // relative to the nearest positioned ancestor (e.g. a sticky parent)
        // and would return ~0, making the check fire prematurely.
        const hasScrolledPastTrigger = !entry.isIntersecting && entry.boundingClientRect.top < 0;

        this.updateState({
          isTriggerVisible: !hasScrolledPastTrigger,
        });
      }

      handleFooterIntersection(entries) {
        const entry = entries[0];
        this.updateState({
          isFooterIntersecting: entry.isIntersecting,
        });
      }

      updateState(newState) {
        this.state = { ...this.state, ...newState };
        this.updateVisibility();
      }

      updateVisibility() {
        const shouldShow = !this.state.isTriggerVisible && !this.state.isFooterIntersecting;
        this.elements.stickyProduct.classList.toggle('show', shouldShow);
        this.updateTopOffset();
      }

      setupResizeHandling() {
        if (this.elements.position !== 'top') {
          return;
        }

        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(this.updateTopOffset.bind(this));
          this.resizeObserver.observe(this.elements.stickyProduct);
        }

        window.addEventListener('resize', this.updateTopOffset.bind(this));
      }

      updateTopOffset() {
        const visibleTopStickyProducts = Array.from(document.querySelectorAll('.sticky-product--top.show'));

        if (visibleTopStickyProducts.length === 0) {
          document.body.classList.remove('sticky-cta-top-visible');
          document.documentElement.style.removeProperty('--sticky-cta-height');
          return;
        }

        const stickyHeight = Math.max(
          ...visibleTopStickyProducts.map(
            (stickyProduct) => stickyProduct.getBoundingClientRect().height || stickyProduct.offsetHeight,
          ),
        );

        document.documentElement.style.setProperty('--sticky-cta-height', `${stickyHeight}px`);
        document.body.classList.add('sticky-cta-top-visible');
      }

      setupEventListeners() {
        this.elements.stickyButton.addEventListener('click', this.handleButtonClick.bind(this));
      }

      handleButtonClick() {
        if (this.elements.isSingleProduct) {
          return this.handleSingleProductClick();
        }

        const isDisabled = this.elements.stickyButton.dataset.disabled === 'true';
        return isDisabled ? this.handleScrollToTarget() : this.handleBundleClick();
      }

      handleSingleProductClick() {
        const singleContainer =
          this.elements.stickyProduct.closest(
            '[data-trial-pack], [data-single-product-container-v2], [data-single-product-container]',
          ) ||
          document.querySelector(
            '[data-trial-pack], [data-single-product-container-v2], [data-single-product-container]',
          );
        const addButton = singleContainer?.querySelector('[data-add-to-cart]');
        if (!addButton) {
          return;
        }

        addButton.click();
      }

      handleScrollToTarget() {
        if (!this.elements.scrollTarget) {
          return;
        }

        this.elements.scrollTarget.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }

      handleBundleClick() {
        const bundlesContainer =
          this.elements.stickyProduct.closest(
            '[data-promo-subscription-builder], [data-single-bundle-container], [data-bundles-container-v2], [data-bundles-container]',
          ) ||
          document.querySelector(
            '[data-promo-subscription-builder], [data-single-bundle-container], [data-bundles-container-v2], [data-bundles-container]',
          );
        if (!bundlesContainer) {
          return;
        }

        const activeBundleId = bundlesContainer.dataset.activeBundle;
        const addButton = bundlesContainer.querySelector(
          `[data-add-to-cart][data-active-on-bundle="${activeBundleId}"]`,
        );

        if (!addButton) {
          return;
        }

        addButton.click();
      }
    }

    new StickyProductController();
  });
  } catch(e) { console.error(e); }
})();

})();
